import { Descriptions } from "antd";
import { t } from "i18next";

import FilterableTableLayout from "../../../../components/FilterableTableLayout/FilterableTableLayout";
import { PersistedFilterKeys } from "../../../../modules/filters/filters.types";
import { useMfinEvidentiraneMarkiceList } from "../../../../modules/ministry/ministry.queries";
import {
  MfinEvidentiranaMarkica,
  MfinListaEvidentiranihAkciznihMarkicaPayload,
  MfinListaEvidentiranihAkciznihMarkicaResponse,
} from "../../../../modules/ministry/ministry.types";
import {
  getMfinEvidentiraneMarkiceFilterItems,
  getMfinEvidentiraneMarkiceTableColumns,
  MFIN_EVIDENTIRANE_MARKICE_INITIAL_FILTERS,
} from "../../../../modules/ministry/ministry.usedStamps.constants";
import { KategorijaEvidentiraneMarkice } from "../../../../modules/obligee/usedStamps/usedStamps.types";
import { mapSelectOptions } from "../../../../utils/map4select";
import { MinistryUsedStampsExcelExportButton } from "./MinistryUsedStampsExcelExportButton";
import style from "./MinistryUsedStampsList.module.scss";

const EMPTY_VALUE = "-";

export const MinistryUsedStampsList = () => {
  const renderAdditionalInfoRow = (
    data: MfinListaEvidentiranihAkciznihMarkicaResponse | undefined
  ) => (
    <Descriptions
      bordered
      column={2}
      size="small"
      items={[
        {
          key: "pib",
          label: t("COMMON.PIB"),
          children: data?.pib ?? EMPTY_VALUE,
        },
        {
          key: "psNaziv",
          label: t("TABLES.NAZIV_PRIVREDNOG_SUBJEKTA"),
          children: data?.psNaziv ?? EMPTY_VALUE,
          span: 2,
        },
      ]}
      className={style.descriptions}
    />
  );

  return (
    <FilterableTableLayout<
      MfinEvidentiranaMarkica,
      MfinListaEvidentiranihAkciznihMarkicaResponse,
      MfinListaEvidentiranihAkciznihMarkicaPayload
    >
      tableRowKey="opsegId"
      dataListKey="evidentiraneMarkice"
      queryHook={useMfinEvidentiraneMarkiceList}
      getTableColumns={(payload) =>
        getMfinEvidentiraneMarkiceTableColumns(
          payload?.kategorijaEvidentiranihMarkicaId ??
            KategorijaEvidentiraneMarkice.ISKORISCENE_PROIZVODNJA
        )
      }
      tableName="mfin-evidentirane-markice-tabela"
      title={t("NAVIGATION.LISTA_EVIDENTIRANIH_MARKICA")}
      toolbarId="mfin_evidentirane_markice_list"
      filterProps={{
        getFilterItems: ({ kategorijeEvidentiranja, pib, filters }) =>
          getMfinEvidentiraneMarkiceFilterItems({
            kategorijeEvidentiranja: mapSelectOptions({
              labelAccessor: "name",
              valueAccessor: "id",
              sourceArray: kategorijeEvidentiranja ?? [],
            }),
            hasResponse: Boolean(pib),
            selectedKategorijaEvidentiranihMarkicaId:
              filters?.kategorijaEvidentiranihMarkicaId,
          }),
        initialFilters: MFIN_EVIDENTIRANE_MARKICE_INITIAL_FILTERS,
        persistedFilterKey: PersistedFilterKeys.MFIN_EVIDENTIRANE_MARKICE_LIST,
        triggerQueryManually: true,
        applyDisabledIfEmpty: ["pib"],
      }}
      renderToolbarActions={({ payload, data }) => (
        <MinistryUsedStampsExcelExportButton payload={payload} data={data} />
      )}
      renderAdditionalInfoRow={renderAdditionalInfoRow}
    />
  );
};
